import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import '../../i18n';
import { useTranslation } from 'react-i18next';

const ImgMediaCard = ({ image, name, description, id }) => {
  const { t } = useTranslation(); // t is the translation function
  return (
    <Card
      sx={{
        maxWidth: 345,
        backgroundColor: 'beige',
        border: '2px solid black',
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // Ensure cards take full available height
      }}
    >
      <CardMedia
        component="img"
        alt={name}
        height="210"
        image={image}
      />
      <CardContent
        sx={{
          flexGrow: 1, // Allow content to fill the available space
          overflow: 'hidden', // Hide overflowed content
        }}
      >
        <Typography gutterBottom variant="h5" component="div">
          {name}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            display: '-webkit-box',
            WebkitLineClamp: 3, // Limit text to 3 lines
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis', // Add ellipsis when text overflows
          }}
        >
          {description}
        </Typography>
      </CardContent>
      <CardActions>
        <Link to={`/discover/deal/${id}`}>
          <Button size="small">{t('navigation:learnMore')}</Button>
        </Link>
        <Link to={'/support'}>
          <Button size="small">{t('navigation:contact')}</Button>
        </Link>
      </CardActions>
    </Card>
  );
};

export default ImgMediaCard;
